import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-unmatched-statement-items.presenters.UnmatchedStatementItemListPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load the statement items.',
  },
})
